// TODO：これ見ながらやる
export default {
    'any.required': '{{#label}}を入力してください',
    'string.empty': '{{#label}}を入力してください',
    'object.base': '{{#label}}を入力してください',
    'date.base': '{{#label}}を入力してください',
    'number.empty': '{{#label}}を入力してください',
    'number.base': '{{#label}}を数値で入力してください',
    'number.min': '{{:#limit}}以上で入力してください',
    'number.max': '{{:#limit}}以下で入力してください',
    'number.integer': '{{#label}}を整数で入力してください',
    'string.uri': '{{#label}}で入力してください',
    'string.min': '{{#label}}の入力が短すぎます',
    'number.unsafe': '適切な値を入力してください', // 追加
    'array.min': '{{#label}}を1つ以上選択してください',
}
